import React, { useState } from 'react';
import '../../styles/ekyb.css';

const StepUBO = ({ onContinue }) => {
  const [ubos, setUbos] = useState([
    { id: 1, name: '', dob: '', nationality: '', ownership: '' }
  ]);

  const addUBO = () => {
    const newId = Math.max(...ubos.map(u => u.id), 0) + 1;
    setUbos([...ubos, { id: newId, name: '', dob: '', nationality: '', ownership: '' }]);
  };

  const removeUBO = (id) => {
    if (ubos.length > 1) {
      setUbos(ubos.filter(ubo => ubo.id !== id));
    }
  };

  const updateUBO = (id, field, value) => {
    setUbos(ubos.map(ubo =>
      ubo.id === id ? { ...ubo, [field]: value } : ubo
    ));
  };

  const isValid = () => {
    return ubos.every(ubo =>
      ubo.name.trim() &&
      ubo.dob &&
      ubo.nationality.trim() &&
      ubo.ownership &&
      parseFloat(ubo.ownership) >= 25
    );
  };

  const handleContinue = () => {
    if (isValid()) {
      onContinue(ubos);
    }
  };

  return (
    <div className="ekyb-step-container">
      <div className="ekyb-step-header">
        <h2 className="ekyb-step-title">Ultimate Beneficial Owners</h2>
        <p className="ekyb-step-subtitle">
          Identify all individuals who own or control 25% or more of the entity. At least one UBO must be specified for AML screening.
        </p>
      </div>

      <div className="ekyb-alert info">
        <strong>UBO Data Entry Required:</strong> Ultimate Beneficial Owner information is restricted data not available in public registries. Under AMLD6, entities must identify all UBOs with 25% or greater ownership or control. Please enter this information manually.
      </div>

      <table className="ekyb-ubo-table">
        <thead>
          <tr>
            <th>Full Name</th>
            <th>Date of Birth</th>
            <th>Nationality</th>
            <th>Ownership %</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {ubos.map((ubo) => (
            <tr key={ubo.id}>
              <td>
                <input
                  type="text"
                  className="ekyb-input"
                  style={{ width: '100%' }}
                  placeholder="John Smith"
                  value={ubo.name}
                  onChange={(e) => updateUBO(ubo.id, 'name', e.target.value)}
                />
              </td>
              <td>
                <input
                  type="date"
                  className="ekyb-input"
                  style={{ width: '100%' }}
                  value={ubo.dob}
                  onChange={(e) => updateUBO(ubo.id, 'dob', e.target.value)}
                />
              </td>
              <td>
                <input
                  type="text"
                  className="ekyb-input"
                  style={{ width: '100%' }}
                  placeholder="Finnish"
                  value={ubo.nationality}
                  onChange={(e) => updateUBO(ubo.id, 'nationality', e.target.value)}
                />
              </td>
              <td>
                <input
                  type="number"
                  className="ekyb-input"
                  style={{ width: '100%' }}
                  placeholder="25"
                  min="25"
                  max="100"
                  value={ubo.ownership}
                  onChange={(e) => updateUBO(ubo.id, 'ownership', e.target.value)}
                />
              </td>
              <td style={{ textAlign: 'center' }}>
                {ubos.length > 1 && (
                  <button
                    className="ekyb-button ekyb-button-secondary"
                    onClick={() => removeUBO(ubo.id)}
                    style={{ padding: '8px 12px', fontSize: '12px' }}
                  >
                    Remove
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="ekyb-button-group">
        <button
          className="ekyb-button ekyb-button-secondary"
          onClick={addUBO}
        >
          Add Another UBO
        </button>
        <button
          className="ekyb-button ekyb-button-primary"
          onClick={handleContinue}
          disabled={!isValid()}
        >
          Continue to AML Screening
        </button>
      </div>
    </div>
  );
};

export default StepUBO;
